import { useState } from "react"
import { Card, Typography, TextField, Button, Grid, CircularProgress } from "@mui/material"
import RucResults from "./RucResults"
import { useForm } from "react-hook-form"
import { Box } from "@mui/system";

const RucForm = (props) => {

    const { register, getValues, reset, handleSubmit } = useForm();

    const [ruc, setRuc] = useState({})
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState(false)

    const onSubmit = () => {
        const data = getValues();
        if (!data?.ruc)
            return

        setLoading(true)
        setRuc(data)
    }

    return (
        <Grid container justifyContent="center">
            <Grid item lg={12} xs={12} sm={12} md={12}>
                <Box component="form" onSubmit={handleSubmit(onSubmit)}>
                    <Card sx={{ p: 3, borderRadius: 2, border: "1px solid #e0e0e0" }}>
                        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600 }}>
                            Consultar información.
                        </Typography>
                        <TextField
                            {...register('ruc')}
                            fullWidth
                            label="RUC"
                            placeholder="Ingrese el RUC"
                            variant="outlined"
                            size="small"
                            type="number"
                            sx={{ mb: 2 }}
                            inputProps={{ min: 0 }}
                        />
                        <Grid display="flex" justifyContent="center">
                            <Button
                                type="submit"
                                variant="contained"
                                disabled={loading}
                                // onClick={() => onSubmit()}
                                sx={{
                                    bgcolor: "#fb8c00",
                                    color: "#fff",
                                    fontWeight: 600,
                                    "&:hover": { bgcolor: "#f57c00" },
                                }}
                            >
                                {loading ? (
                                    <CircularProgress size={24} sx={{ color: "white" }} />
                                ) : (
                                    "Consultar"
                                )}
                            </Button>
                        </Grid>
                    </Card>
                </Box>
            </Grid>
            <RucResults data={ruc} setRuc={setRuc} result={result} setResult={setResult} reset={reset} setLoading={setLoading} />
        </Grid>
    )
}
export default RucForm
